export enum BaggageSize {
	small,
	middle,
	large
}
